import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import { API_URL } from "../../shared/constant";
import axios from "axios";
import { toast } from "react-toastify";
import { Watch } from "react-loader-spinner";
import DatePicker from "react-date-picker";
import moment from "moment";

const UserAdd = () => {
  const navigate = useNavigate();
  let { id } = useParams();
  const [statesData, setStatesData] = useState([]);
  const [Previewimage, setPreviewImage] = useState("");
  const [darkPreviewImage, setDarkPreviewImage] = useState("");
  const [isError, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isAllowed, setIsAllowed] = useState(false);
  const [formValue, setFormValue] = useState({
    id: null,
    name: "",
    city: "",
    state_id: "",
    address: "",
    pincode: "",
    email: "",
    logo: "",
    dark_logo: "",
    contact_no: "",
    password: "",
    website: "",
    page_type: "Vertical",
    password_confirmation: "",
    exp_date: null,
  });

  const styles = {
    menu: (baseStyles, state) => ({
      ...baseStyles,
      marginTop: 2,
    }),
  };

  const resetForm = () => {
    setFormValue({
      id: null,
      name: "",
      city: "",
      state_id: "",
      address: "",
      pincode: "",
      logo: "",
      dark_logo: "",
      email: "",
      contact_no: "",
      password: "",
      exp_date: "",
      website: "",
      page_type: "Vertical",
      password_confirmation: "",
    });
  };
  const imageTypes = [
    {
      label: "Horizontal",
      value: "Horizontal",
    },
    {
      label: "Vertical",
      value: "Vertical",
    },
  ];

  const getStates = () => {
    axios.post(API_URL.STATES_LIST, {}).then((res) => {
      if (res.data.status === 1) {
        let stsData = res.data.data.map((row) => {
          return { label: row.name, value: row.id };
        });
        setStatesData(stsData);
      }
    });
  };

  const onEdit = () => {
    setLoading(true);
    axios
      .post(API_URL.USER_GET, { id: id })
      .then((res) => {
        if (res.data.status === 1) {
          setFormValue({
            id: res.data.data.id,
            name: res.data.data.name ? res.data.data.name : "",
            city: res.data.data.city ? res.data.data.city : "",
            state_id: res.data.data.state_id ? res.data.data.state_id : "",
            address: res.data.data.address ? res.data.data.address : "",
            pincode: res.data.data.pincode ? res.data.data.pincode : "",
            email: res.data.data.email ? res.data.data.email : "",
            logo: null,
            dark_logo: null,
            website: res.data.data.website ? res.data.data.website : "",
            exp_date: res.data.data.exp_date
              ? new Date(res.data.data.exp_date)
              : "",
            page_type: res.data.data.page_type ? res.data.data.page_type : "",
            contact_no: res.data.data.contact_no
              ? res.data.data.contact_no
              : "",
            password_confirmation: res.data.data.password_confirmation
              ? res.data.data.password_confirmation
              : "",
            password: res.data.data.password ? res.data.data.password : "",
          });
          setPreviewImage(res.data.data.logo);
          if (res.data.data.dark_logo) {
            setDarkPreviewImage(res.data.data.dark_logo);
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Failed to fetch user data", {
          autoClose: 3000,
          position: "top-center",
        });
      });
  };

  const saveUser = () => {
    if (
      formValue.name &&
      formValue.email &&
      formValue.address &&
      formValue.city &&
      formValue.contact_no &&
      formValue.pincode &&
      formValue.page_type &&
      formValue.state_id &&
      formValue.exp_date
    ) {
      if (
        !id &&
        (!formValue.logo ||
          !formValue.password ||
          !formValue.password_confirmation)
      ) {
        setError(true);
        toast.error("Please enter valid details", {
          autoClose: 3000,
          position: "top-center",
        });
      }
      setLoading(true);
      setError(false);
      var formData = new FormData();
      if (formValue.logo) {
        formData.append("logo", formValue.logo);
      }
      if (formValue.dark_logo) {
        formData.append("dark_logo", formValue.dark_logo);
      }
      formData.append("name", formValue.name);
      formData.append("id", formValue.id);
      formData.append("city", formValue.city);
      formData.append("state_id", formValue.state_id);
      formData.append("address", formValue.address);
      formData.append("pincode", formValue.pincode);
      formData.append("email", formValue.email);
      formData.append("page_type", formValue.page_type);
      formData.append(" website", formValue.website);
      formData.append("contact_no", formValue.contact_no);
      if (formValue.exp_date) {
        formData.append(
          "exp_date",
          moment(formValue.exp_date).format("YYYY-MM-DD")
        );
      }
      if (formValue.password) {
        formData.append("password", formValue.password);
        formData.append(
          "password_confirmation",
          formValue.password_confirmation
        );
      }
      const pUrl = id ? API_URL.USER_UPDATE : API_URL.USER_SAVE;
      axios.post(pUrl, formData).then((res) => {
        setLoading(false);
        if (res.data.status === 1) {
          if (id) {
            toast.success("Updated", {
              autoClose: 3000,
              position: "top-center",
            });
            setTimeout(() => {
              navigate("/admin/user", { replace: true });
            }, 100);
          } else {
            resetForm();
            toast.success("Saved", { autoClose: 3000, position: "top-center" });
          }
        } else {
          toast.error(res.data.data, {
            autoClose: 3000,
            position: "top-center",
          });
        }
      });
      setLoading(false);
    } else {
      setError(true);
      toast.error("Please enter valid details", {
        autoClose: 3000,
        position: "top-center",
      });
    }
  };

  const isShowError = (value) => {
    if (
      isError &&
      (!value || value === "" || value === null || value === undefined)
    ) {
      return true;
    }
    return false;
  };
  const getInputStyles = (isError) => ({
    borderColor: isError ? "red" : undefined,
  });
  const setFormData = (name, value) => {
    setFormValue({ ...formValue, [name]: value });
  };

  const userInfo = () => {
    axios.post(API_URL.LOGIN_USER, {}).then((res) => {
      if (res.data) {
        setIsAllowed(res.data.is_allowed);
        if (res.data.is_allowed) {
          if (id) {
            onEdit();
          }
        } else {
          navigate("/admin/dashboard", { replace: true });
        }
      }
    });
  };

  useEffect(() => {
    userInfo();
    getStates();
  }, []);

  return (
    <>
      {isAllowed && (
        <div className="page-header">
          <div className="content-page-header">
            <h5>{id ? "Edit" : "Add"} User</h5>
            <div className="list-btn">
              <ul className="filter-list">
                <li>
                  <Link to={"/admin/user"} className="btn btn-sm btn-secondary">
                    <i className="fa fa-backward me-2" aria-hidden="true"></i>
                    Back
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}
      {isAllowed && (
        <div className="card">
          <div className="card-body">
            <form onSubmit={(event) => event.preventDefault()}>
              <div className="row">
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="form-group">
                    <label
                      className={`form-label ${
                        isShowError(formValue.name) && "required-field"
                      }`}
                    >
                      Name<span className="required-star">*</span>
                    </label>
                    <input
                      type="text"
                      value={formValue.name}
                      style={getInputStyles(isShowError(formValue.name))}
                      onChange={(e) => setFormData("name", e.target.value)}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="form-group">
                    <label
                      className={`form-label ${
                        isShowError(formValue.address) && "required-field"
                      }`}
                    >
                      Address<span className="required-star">*</span>
                    </label>
                    <input
                      type="text"
                      value={formValue.address}
                      style={getInputStyles(isShowError(formValue.address))}
                      onChange={(e) => setFormData("address", e.target.value)}
                      className="form-control"
                    />
                  </div>
                </div>

                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="form-group">
                    <label
                      className={`form-label ${
                        isShowError(formValue.city) && "required-field"
                      }`}
                    >
                      City<span className="required-star">*</span>
                    </label>
                    <input
                      type="text"
                      value={formValue.city}
                      style={getInputStyles(isShowError(formValue.city))}
                      onChange={(e) => setFormData("city", e.target.value)}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="form-group">
                    <label
                      className={`form-label ${
                        isShowError(formValue.state_id) && "required-field"
                      }`}
                    >
                      State<span className="required-star">*</span>
                    </label>
                    <Select
                      options={statesData}
                      value={statesData.find(
                        (r) => r.value == formValue.state_id
                      )}
                      styles={{
                        ...styles,
                        control: (base) => ({
                          ...base,
                          borderColor: isShowError(formValue.state_id)
                            ? "red"
                            : base.borderColor,
                        }),
                      }}
                      onChange={(e) => setFormData("state_id", e.value)}
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="form-group">
                    <label
                      className={`form-label ${
                        isShowError(formValue.pincode) && "required-field"
                      }`}
                    >
                      Pincode<span className="required-star">*</span>
                    </label>
                    <input
                      type="number"
                      value={formValue.pincode}
                      style={getInputStyles(isShowError(formValue.pincode))}
                      onChange={(e) => setFormData("pincode", e.target.value)}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="form-group">
                    <label
                      className={`form-label ${
                        isShowError(formValue.contact_no) && "required-field"
                      }`}
                    >
                      Contact Number<span className="required-star">*</span>
                    </label>
                    <input
                      maxLength={10}
                      type="no"
                      value={formValue.contact_no}
                      style={getInputStyles(isShowError(formValue.contact_no))}
                      onChange={(e) =>
                        setFormData("contact_no", e.target.value)
                      }
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="form-group">
                    <label
                      className={`form-label ${
                        isShowError(formValue.website) && "required-field"
                      }`}
                    >
                      Web Site<span className="required-star">*</span>
                    </label>
                    <input
                      type="text"
                      value={formValue.website}
                      style={getInputStyles(isShowError(formValue.website))}
                      onChange={(e) => setFormData("website", e.target.value)}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="form-group">
                    <label
                      className={`form-label ${
                        isShowError(formValue.email) && "required-field"
                      }`}
                    >
                      Email<span className="required-star">*</span>
                    </label>
                    <input
                      type="email"
                      value={formValue.email}
                      style={getInputStyles(isShowError(formValue.email))}
                      onChange={(e) => setFormData("email", e.target.value)}
                      className="form-control"
                    />
                  </div>
                </div>

                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="form-group">
                    <label
                      className={`form-label ${
                        isShowError(formValue.password) && "required-field"
                      }`}
                    >
                      Password<span className="required-star">*</span>
                    </label>
                    <input
                      type="password"
                      value={formValue.password}
                      style={getInputStyles(isShowError(formValue.password))}
                      onChange={(e) => setFormData("password", e.target.value)}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="form-group">
                    <label
                      className={`form-label ${
                        isShowError(formValue.password_confirmation) &&
                        "required-field"
                      }`}
                    >
                      Confirm Password<span className="required-star">*</span>
                    </label>
                    <input
                      type="password"
                      value={formValue.password_confirmation}
                      style={getInputStyles(
                        isShowError(formValue.password_confirmation)
                      )}
                      onChange={(e) =>
                        setFormData("password_confirmation", e.target.value)
                      }
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="form-group">
                    <label
                      className={`form-label ${
                        isShowError(formValue.page_type) && "required-field"
                      }`}
                    >
                      Page Type<span className="required-star">*</span>
                    </label>
                    <Select
                      options={imageTypes}
                      value={imageTypes.find(
                        (r) => r.value === formValue.page_type
                      )}
                      styles={styles}
                      onChange={(e) => {
                        setFormValue({
                          ...formValue,
                          page_type: e.value || null,
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="form-group">
                    <label
                      className={`form-label ${
                        isShowError(formValue.exp_date) && "required-field"
                      }`}
                    >
                      Expiry<span className="required-star">*</span>
                    </label>
                    <DatePicker
                      value={formValue.exp_date}
                      onChange={(date) =>
                        setFormValue({ ...formValue, exp_date: date })
                      }
                      styles={{
                        ...styles,
                        control: (base) => ({
                          ...base,
                          borderColor: isShowError(formValue.exp_date)
                            ? "red"
                            : base.borderColor,
                        }),
                      }}
                      className="form-control"
                      format="dd/MM/y"
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="form-group">
                    <label
                      className={`form-label ${
                        isShowError(formValue.logo) && "required-field"
                      }`}
                    >
                      Original Logo<span className="required-star">*</span>
                    </label>
                    <input
                      type="file"
                      name="logo"
                      className="form-control"
                      id="logo"
                      style={getInputStyles(isShowError(formValue.logo))}
                      onChange={(event) => {
                        if (event.target.files) {
                          let file = event.target.files[0];
                          const allowedFileTypes = [
                            "image/jpeg",
                            "image/jpg",
                            "image/png",
                          ];
                          if (!allowedFileTypes.includes(file.type)) {
                            toast.error(
                              "Only JPEG, JPG, and PNG files are allowed.",
                              {
                                autoClose: 3000,
                                position: "top-center",
                              }
                            );
                            setFormValue({ ...formValue, logo: null });
                            event.target.value = "";
                            return;
                          }
                          if (file.size > 2 * 1024 * 1024) {
                            toast.error(
                              "File size must be less than or equal to 2MB.",
                              {
                                autoClose: 3000,
                                position: "top-center",
                              }
                            );
                            setFormValue({ ...formValue, logo: null });
                            event.target.value = "";
                            return;
                          }
                          var reader = new FileReader();
                          reader.readAsDataURL(file);
                          reader.onload = function () {
                            setFormValue({
                              ...formValue,
                              logo: file,
                            });
                            setPreviewImage(reader.result);
                          };
                        } else {
                          setFormValue({ ...formValue, logo: null });
                          setPreviewImage("");
                        }
                      }}
                    />
                    {Previewimage && (
                      <img
                        src={Previewimage}
                        alt="Previewimage"
                        style={{
                          maxWidth: "100%",
                          maxHeight: "100px",
                          marginTop: "10px",
                        }}
                      />
                    )}
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="form-group">
                    <label>White Logo</label>
                    <input
                      type="file"
                      name="dark_logo"
                      className="form-control"
                      id="dark_logo"
                      onChange={(event) => {
                        if (event.target.files) {
                          let file = event.target.files[0];
                          const allowedFileTypes = [
                            "image/jpeg",
                            "image/jpg",
                            "image/png",
                          ];

                          // Validate file type
                          if (!allowedFileTypes.includes(file.type)) {
                            toast.error(
                              "Only JPEG, JPG, and PNG files are allowed.",
                              {
                                autoClose: 3000,
                                position: "top-center",
                              }
                            );
                            setFormValue({ ...formValue, dark_logo: null });
                            event.target.value = ""; // Clear the file input
                            return;
                          }

                          // Validate file size (2MB limit)
                          if (file.size > 2 * 1024 * 1024) {
                            toast.error(
                              "File size must be less than or equal to 2MB.",
                              {
                                autoClose: 3000,
                                position: "top-center",
                              }
                            );
                            setFormValue({ ...formValue, dark_logo: null });
                            event.target.value = ""; // Clear the file input
                            return;
                          }

                          // If validation passes, update the form value and preview the image
                          var reader = new FileReader();
                          reader.readAsDataURL(file);
                          reader.onload = function () {
                            setFormValue({
                              ...formValue,
                              dark_logo: file,
                            });
                            setDarkPreviewImage(reader.result); // Set the preview image
                          };
                        } else {
                          setFormValue({ ...formValue, dark_logo: null });
                          setDarkPreviewImage(""); // Clear the preview image
                        }
                      }}
                    />
                    {darkPreviewImage && (
                      <img
                        src={darkPreviewImage}
                        alt="Logo"
                        style={{
                          maxWidth: "100%",
                          maxHeight: "100px",
                          marginTop: "10px",
                        }}
                      />
                    )}
                  </div>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="form-group text-end">
                    <button
                      type="submit"
                      onClick={saveUser}
                      className="btn btn-sm btn-primary"
                      disabled={loading}
                    >
                      {loading ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Watch color={"white"} height={20} width={20} />
                        </div>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </div>
                <div
                  className="d-flex justify-content-start"
                  style={{ color: "red" }}
                >
                  The maximum limit of file size is 2MB
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default UserAdd;
